import { Component, Input, OnInit } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";
import { HomePage } from "../home/home";

@IonicPage()
@Component({
  selector: "page-video-tutorial-modal",
  templateUrl: "video-tutorial-modal.html",
})
export class VideoTutorialModalPage implements OnInit {
  @Input() data: any;
  title: string = "Video Tutorial";
  vdoUrl: string;
  theme = 1;

  constructor(
    public navParams: NavParams,
    private storage: Storage,
    public navCtrl: NavController
  ) {
    // console.log("vdo===>", this.navParams.data.vdo);
    this.vdoUrl = this.navParams.data.vdo;
  }

  async ngOnInit() {
    this.theme = await this.storage.get("theme");

    // this.navParams.data.id;
    if (this.navParams.data.id == 18) {
      this.title = "Rent out space";
    } else if (this.navParams.data.id == 19) {
      this.title = "Invest in social shop";
    } else if (this.navParams.data.id == 20) {
      this.title = "Invest in theme";
    } else if (this.navParams.data.id == 21) {
      this.title = "Check plaza map";
    } else if (this.navParams.data.id == 22) {
      this.title = "Collect rental fee";
    } else if (this.navParams.data.id == 23) {
      this.title = "Remove social shop";
    } else if (this.navParams.data.id == 24) {
      this.title = "Add social ticket";
    } else if (this.navParams.data.id == 25) {
      this.title = "Change theme";
    } else if (this.navParams.data.id == 26) {
      this.title = "Rent space from plaza";
    } else if (this.navParams.data.id == 27) {
      this.title = "Check your stock";
    } else if (this.navParams.data.id == 28) {
      this.title = "Remove your shop";
    } else if (this.navParams.data.id == 29) {
      this.title = "Refill stock";
    } else if (this.navParams.data.id == 30) {
      this.title = "Pay rental fee";
    } else if (this.navParams.data.id == 31) {
      this.title = "Create social group";
    } else if (this.navParams.data.id == 32) {
      this.title = "Join social group";
    } else if (this.navParams.data.id == 33) {
      this.title = "Buy social ticket";
    } else if (this.navParams.data.id == 34) {
      this.title = "Buy product";
    } else if (this.navParams.data.id == 35) {
      this.title = "Check shop in Plaza";
    } else if (this.navParams.data.id == 12 || this.navParams.data.id == 14) {
      this.title = "Score Calculation";
    } else if (this.navParams.data.id == 13 || this.navParams.data.id == 15) {
      this.title = "วิธีการคำนวณคะแนน";
    } else if (this.navParams.data.id == 16 || this.navParams.data.id == 17) {
      this.title = "Summary";
    } else {
      this.title = "The Instruction";
    }
  }

  backPage() {
    this.navCtrl.pop();
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/video-tutorial-modal/video-tutorial-modal.ts